import React from 'react';
import PropTypes from 'prop-types';

import CityVenueCard from '../react-city-venue-card/cityVenueCard';

import './index.scss';

const CityVenueList = ({venues, title, screenSize, enableSubGenreModuleDesktop, isRedirectModalEnabled}) =>
  venues.length > 0 && (
    <div className="VenueList">
      <h2 className="VenueListTitle">{title}</h2>
      {venues.map((item) => (
        <CityVenueCard
          enableSubGenreModuleDesktop={enableSubGenreModuleDesktop}
          screenSize={screenSize}
          id={item.venueId}
          key={item.venueId}
          name={item.venueName}
          address={item.venue}
          events={item.events}
          isRedirectModalEnabled={isRedirectModalEnabled}
        />
      ))}
    </div>
  );

CityVenueList.propTypes = {
  /** Array of venues */
  venues: PropTypes.array,

  /** Title */
  title: PropTypes.string,

  /** Device screen size */
  screenSize: PropTypes.string,

  enableSubGenreModuleDesktop: PropTypes.bool,

  /** Is redirection modal enabled? */
  isRedirectModalEnabled: PropTypes.bool,
};

export default CityVenueList;
